<template>
<section class="mbs-wrap mbs012c" :style="dBHeight">
        <section class="mbs-header">
            <div class="inner">
                <div class="tit-box">
                    <h3>{{$i18nUtil.trans("title.MyInfo.001","내 정보 관리")}}</h3>
                </div>
            </div>
        </section>
        <div class="pw-box photo-box">
            <div class="photo">
                <!-- <img src="../../../../../assets/img/noimg.png" alt="사람이름"> -->
                <img id="viewPhoto" alt="" />
            </div>
            <div class="info" v-if="userInfo !== null"
                 v-html="$i18nUtil.trans('message.ViewInfo.001','* 계정 사용 가능한 기간이 {remainDay}일 남았습니다.',{remainDay:userInfo.remainDay})">
                <div class="droplayer icon info tip relative">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">설명</v-btn>
                        </template>
                        <div class="dropdown-list ">
                            <div class="tooltip-b tl" style="width: 373px;">
                                <p>{{$i18nUtil.trans("message.ViewInfo.002","사용권한 연장이 필요한 경우 초대한 담당자에게 계정사용 연장을 요청해주세요.")}}</p>
                                <ul class="ref">
                                    <li>{{$i18nUtil.trans("message.ViewInfo.003","* 연장되지 않은 계정은 사용만료일 이후 서비스 접근이 차단됩니다.")}}</li>
                                    <li>{{$i18nUtil.trans("message.ViewInfo.004","* 계정연장은 전자결재에서 담당자가 신청 가능합니다.")}}</li>
                                </ul>
                            </div>
                        </div>
                    </v-menu>
                </div>
            </div>
            <ul class="list-table" v-if="userInfo !== null" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' ">
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.name","이름")}}</dt>
                        <dd>{{userInfo.userName}}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.email","이메일")}}</dt>
                        <dd>{{userInfo.email}}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.partnerName","소속회사")}}</dt>
                        <dd>{{userInfo.partnerName}}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.cellPhoneNo","휴대폰번호")}}</dt>
                        <dd>{{userInfo.cellPhoneNo}}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("message.ViewInfo.005","비밀번호 변경")}}</dt>
                        <dd>{{$i18nUtil.trans("message.ViewInfo.006","우측 버튼을 통해 비밀번호를 변경하세요.")}}<button type="button" class="btn-primary-small" @click="modifyPasswordPop">{{$i18nUtil.trans("button.ViewInfo.001","비밀번호 변경")}}</button></dd>
                    </dl>
                </li>
            </ul>
        </div>
        <div class="btn-box txtc">
            <button type="button" class="btn-primary-medium black" @click="modifyUserInfo">{{$i18nUtil.trans("button.ViewInfo.002","내 정보 수정")}}</button>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ModifyPassword from "../modal/ModifyPassword";
export default {
    props : ['userInfo'],
    data() {
        return {
            dBHeight: {
                'min-height': (window.innerHeight - 153) + 'px',
            },
        }
    },
    mounted() {
        this.getUserPhoto();
    },
    methods : {
        ...mapActions("modals", ["showModal"]),
        modifyUserInfo() {
            //this.dynamicComponent = 'modify';
            this.$emit('changeStatus', {isModify : true});
        },
        getUserPhoto() {
            let img = document.getElementById("viewPhoto");
            img.style.width = "114px";
            img.style.height = "114px";
            let imageURI = "/api/auth/org/getLoggedUserPhoto";
            let xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
                    img.src = URL.createObjectURL(xhr.response);
                    img.setAttribute("completed", true);
                    img.classList.remove("hidden");
                }
            };
            xhr.open("POST", imageURI, true);
            var token = localStorage.getItem("Authorization");
            xhr.setRequestHeader("Authorization", token);
            xhr.responseType = "blob";
            xhr.send();
        },
        /* 비밀번호 재설정 */
        modifyPasswordPop() {
            const modalInfo = {
                width: "500px",
                height: "519px",
                obj: this.$modal,
                component: ModifyPassword
            };
            this.showModal(modalInfo);
        },
    }
}
</script>

<style scoped>
    .pw-box .enCss > li > dl > dt {
        width: 120px;
    }
</style>


// WEBPACK FOOTER //
// src/components/cowork/common/myInfo/external/ViewInfo.vue